import type { CreditMovement } from '@paguz/contracts';
import { cn } from '@paguz/ui';
import { Link } from '@tanstack/react-router';
import { ChevronRightIcon } from 'lucide-react';
import { PrivateMoney, signedAmount } from '../../components/money.tsx';
import { formatShortDate } from '../../lib/format.ts';
import { MOVEMENT_TYPE } from './labels.ts';

/** Fila de movimiento; las compras y devoluciones llevan al detalle de la utilización. */
export function MovementRow({ movement }: { movement: CreditMovement }) {
  const meta = MOVEMENT_TYPE[movement.type];
  const Icon = meta.icon;
  const content = (
    <>
      <span
        className={cn(
          'flex size-10 shrink-0 items-center justify-center rounded-full',
          meta.isCredit
            ? 'bg-success-soft text-success-soft-foreground'
            : 'bg-secondary text-secondary-foreground',
        )}
      >
        <Icon className="size-5" aria-hidden />
      </span>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-medium">{movement.description}</span>
        <span className="text-sm text-muted-foreground">
          {meta.label} · {formatShortDate(movement.businessDate)}
        </span>
      </span>
      <PrivateMoney
        value={signedAmount(movement.amount.amount, meta.isCredit)}
        sign="always"
        tone={meta.isCredit ? 'positive' : 'default'}
        size="sm"
        className="font-semibold"
      />
      {movement.drawdownId !== null && (
        <ChevronRightIcon className="size-5 shrink-0 text-muted-foreground" aria-hidden />
      )}
    </>
  );
  const className = 'flex min-h-16 items-center gap-3 py-2';
  return movement.drawdownId === null ? (
    <div className={className}>{content}</div>
  ) : (
    <Link
      to="/compras/$drawdownId"
      params={{ drawdownId: movement.drawdownId }}
      className={cn(className, '-mx-2 rounded-lg px-2 hover:bg-accent')}
    >
      {content}
    </Link>
  );
}
